 
function globalRunOnPublishArticle() {
    setOwl('#PublishArtCommodity #Items', false, true, true, false, 0, false, {}, false);
    MarkFC("");
}
function globalRunOnPublishCategory():void {
    ;
}


